import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';


@Injectable({
  providedIn: 'root'
})
export class AppDataServiceService {
  public currentDate:String;
  public i = 0;
  private _baseUrl:string = "http://50.62.22.142/api";
  private httpBackend: HttpClient;
  constructor(
    private http : HttpClient,
    handler: HttpBackend) { 
      this.httpBackend = new HttpClient(handler);

    }
        date:any;
        public globalDate  =  new BehaviorSubject<string>("");
        getdate = this.globalDate.asObservable();
        
        setCurrentDate(data){
           this.currentDate=data;
           return data;
        }
        
        getCurrentDate(date:string){
          console.log(date);
          this.globalDate.next(date);
        }

       getLiveData(){
            console.log('liveData', this.i++);
            return  this.httpBackend.get(`${this._baseUrl}/energy/live`);
          }
       
        getLiveDataProductvity(){
          this.globalDate.subscribe(res=> this.date = res);
          return  this.http.get(`${this._baseUrl}/productivity/live/${this.date}`);
        }   
        getAllDeviceDetails(){
          return  this.http.get(`${this._baseUrl}/energy/DeviceDetail`);
        }  
        getDeviceDetails(id){
          
          return  this.http.get(`${this._baseUrl}/energy/DeviceDetail/${this._baseUrl}`);
        }  
        getDeviceParameters(){
          return  this.http.get(`${this._baseUrl}/energy/parameters`);
        }     

        getDeviceData(deviceId,date,device){
          return  this.http.get(`${this._baseUrl}/energy/`+deviceId+`/`+date+`/`+device);
        }

        getChuckSillyJokes(){
          return  this.httpBackend.get("https://api.chucknorris.io/jokes/random");
        }

        getWeatherData(){
          return  this.httpBackend.get(" http://166.62.91.152/ems_alpha_foam/www/server/getweatherInfo.php?type=onLoad&currentDateTime=2019-11-09+17%3A08%3A00");
        }
      monthNo = {'January' : 1, 
      'February' : 2,
      'March' : 3, 
      'April' : 4, 
      'May' : 5, 
      'June': 6,
      'July' : 7, 
      'August': 8, 
      'September' : 9, 
      'October' :10, 
      'November' : 12, 
      'December' : 13};   

}
